/* unplugin-vue-components disabled */import { render } from "./OrderResult.vue?vue&type=template&id=c84475c4"
import script from "./OrderResult.vue?vue&type=script&lang=js"
export * from "./OrderResult.vue?vue&type=script&lang=js"

import "./OrderResult.vue?vue&type=style&index=0&id=c84475c4&lang=css"

import exportComponent from "E:\\myprogram\\52haoma_new\\new-haoma52\\haoma52-index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__